<div class="teams-wrapper">
  <div class="teams-nav">
    <div class="nav-title">Contents</div>
    <ul>
      <li><a href="#overview" class="nav-link active">Overview</a></li>
      <li><a href="#principal-investigators" class="nav-link">Principal Investigators</a></li>
      <li><a href="#development-team" class="nav-link">Development Team</a></li>
      <li><a href="#past-members" class="nav-link">Past Team & Contributors</a></li>
    </ul>
  </div>

  <div class="teams-container">
    <section id="overview">
      <h1>Team</h1>
      <p>The DOME Registry Team</p>
      <p>The DOME Recommendations and Registry are the result of a collaborative effort involving researchers,
        developers, and experts from various institutions. We acknowledge the contributions of the core team members
        driving this initiative forward.</p>
    </section>

    <section id="principal-investigators">
      <h2>Principal Investigators</h2>
      <p>The Principal Investigators provide strategic leadership, guidance, and oversight for the DOME project, often
        securing funding and representing the initiative within the broader scientific community (e.g., within ELIXIR).
      </p>

      <div class="team-member">
        <div class="member-photo">

          <!-- Placeholder for photo -->
          <div class="photo-placeholder">
            <img src="../../assets/Silvio-Tosatto.png" alt="Silvio Tosatto" class="member-photo-img">
          </div>
        </div>
        <div class="member-info">
          <h3>Silvio Tosatto</h3>
          <p><strong>Role:</strong> Lead PI</p>
          <p><strong>Affiliation:</strong> University of Padova</p>
          <div class="social-links">
            <a href="https://orcid.org/0000-0003-4525-7793" target="_blank" title="ORCID Profile"><i
                class="bi bi-person-badge"></i></a>
            <a href="https://biocomputingup.it/" target="_blank" title="Lab Website"><i class="bi bi-globe"></i></a>
          </div>
        </div>
      </div>

      <div class="team-member">
        <div class="member-photo">
          <!-- Placeholder for photo -->
          <div class="photo-placeholder"> <img src="../../assets/fotis.jpeg" alt="Fotis Psomopoulos"
              class="member-photo-img  "></div>
        </div>
        <div class="member-info">
          <h3>Fotis Psomopoulos</h3>
          <p><strong>Role:</strong> Lead PI</p>
          <p><strong>Affiliation:</strong> CERTH | INAB</p>
          <div class="social-links">
            <a href="https://orcid.org/0000-0002-0222-4273" target="_blank" title="ORCID Profile"><i
                class="bi bi-person-badge"></i></a>
            <a href="https://biodataanalysisgroup.github.io/team/" target="_blank" title="Lab Website"><i
                class="bi bi-globe"></i></a>
          </div>
        </div>
      </div>
    </section>

    <section id="development-team">
      <h2>Development Team</h2>
      <p>This team is responsible for the technical design, implementation, maintenance, and ongoing development of the
        DOME Registry platform, the DOME Wizard, and associated infrastructure.</p>

      <div class="team-member">
        <div class="member-photo">
          <!-- Placeholder for photo -->
          <div class="photo-placeholder">
            <div class="photo-placeholder"> <img src="../../assets/omar.png" alt="Omar Attafi"
                class="member-photo-img  "></div>
          </div>
        </div>
        <div class="member-info">
          <h3>Omar A Attafi</h3>
          <p><strong>Role:</strong> Lead Developer & PhD Researcher</p>
          <p><strong>Affiliation:</strong> University of Padova</p>

          <div class="social-links">
            <a href="https://github.com/Abdelghaniomar" target="_blank" title="GitHub Profile"><i
                class="bi bi-github"></i></a>
            <a href="https://orcid.org/0009-0002-2327-9430" target="_blank" title="ORCID Profile"><i
                class="bi bi-person-badge"></i></a>
            <a href="www.linkedin.com/in/omar-abdelghani-attafi-3509a319a" target="_blank" title="LinkedIn Profile"><i
                class="bi bi-linkedin"></i></a>
          </div>
        </div>
      </div>

      <div class="team-member">
        <div class="member-photo">
          <!-- Placeholder for photo -->
          <div class="photo-placeholder"> <img src="../../assets/ramin.jpeg" alt="Ramin Khalili"
              class="member-photo-img  "></div>
        </div>
        <div class="member-info">
          <h3>Ramin Khalili</h3>
          <p><strong>Role:</strong> Developer & Lab Intern</p>
          <p><strong>Affiliation:</strong> University of Padova</p>

          <div class="social-links">
            <a href="https://github.com/raminkhalilii" target="_blank" title="GitHub Profile"><i
                class="bi bi-github"></i></a>
            <a href="https://orcid.org/0009-0008-0559-9987" target="_blank" title="ORCID Profile"><i
                class="bi bi-person-badge"></i></a>
            <a href="www.linkedin.com/in/raaminkhalil" target="_blank" title="LinkedIn Profile"><i
                class="bi bi-linkedin"></i></a>
          </div>
        </div>
      </div>

      <div class="team-member">
        <div class="member-photo">
          <!-- Placeholder for photo -->
          <div class="photo-placeholder">
            <img src="../../assets/gavin.jpeg" alt="Gavin Farrell" class="member-photo-img  "
              >
          </div>
        </div>
        <div class="member-info">
          <h3>Gavin Farrell</h3>
          <p><strong>Role:</strong> Scaling Curation & PhD Researcher</p>
          <p><strong>Affiliation:</strong> University of Padova</p>

          <div class="social-links">
            <a href="https://github.com/gavinf97" target="_blank" title="GitHub Profile"><i
                class="bi bi-github"></i></a>
            <a href="https://orcid.org/0000-0001-5166-8551" target="_blank" title="ORCID Profile"><i
                class="bi bi-person-badge"></i></a>
            <a href="https://www.linkedin.com/in/gavin-farrell97/" target="_blank" title="LinkedIn Profile"><i
                class="bi bi-linkedin"></i></a>
          </div>
        </div>
      </div>
      <div class="team-member">
        <div class="member-photo">
          <!-- Placeholder for photo -->
          <div class="photo-placeholder">
            <img src="../../assets/ivan.jpeg" alt="Ivan Mičetić" class="member-photo-img  "
            >
          </div>
        </div>
        <div class="member-info">
          <h3>Ivan Mičetić</h3>
          <p><strong>Role:</strong> Lab Services Manager</p>
          <p><strong>Affiliation:</strong> University of Padova</p>

          <div class="social-links">
            <a href="https://github.com/ivanmicetic" target="_blank" title="GitHub Profile"><i
                class="bi bi-github"></i></a>
            <a href="https://orcid.org/0000-0003-1691-8425" target="_blank" title="ORCID Profile"><i
                class="bi bi-person-badge"></i></a>

          </div>
        </div>
      </div>

    </section>

    <section id="past-members">
      <h2>Past Team Members & Contributors</h2>
      <p>We gratefully acknowledge the valuable contributions of former team members who have helped shape and build
        DOME during previous phases of the project.</p>
      <!--  -->
      <div class="team-member">
        <div class="member-info">
          <h3>Damiano Clementel</h3>
          <p><strong>Role during contribution:</strong> Lead developer</p>
          <p><strong>Affiliation during contribution:</strong> University of Padova</p>
          <p><strong>Period:</strong> 2021-2023</p>
           <h3>Styliani-Christina (Stella) Fragkouli</h3>
          <p><strong>Role:</strong> Research Associate</p>
          <p><strong>Affiliation during contribution:</strong> CERTH</p>
           <h3>Konstantinos Kyritsis</h3>
          <p><strong>Role:</strong> Research Associate</p>
          <p><strong>Affiliation during contribution:</strong> CERTH</p>
         <h3> Anastasia (Natasa) Anastasiadou</h3>
          <p><strong>Role:</strong> Research Associate</p>
          <p><strong>Affiliation during contribution:</strong> CERTH</p>
        </div>
      </div>






    </section>
  </div>
</div>
<app-big-footer></app-big-footer>
